import Vue from 'vue'
import Vuex from 'vuex'
import {axios2 as axios} from "@/interceptor/useApi";

Vue.use(Vuex)

export default{
  namespaced:true,
  state: {
    Items : [],
    Loading:true
  },
  getters: {
    Items(state){
      return state.Items
    }
  },
  mutations: {
    LlenarItems(state,data){
      state.Items = data
    },
    LlenarLoading(state,data){
      state.Loading = data
    }
  },
  actions: {
    cargarTipoCambio:async function({commit}){
      try {
        const  url = "tipocambio";
        const data = {
          id_cliente: localStorage.getItem("idcliente"),
        };
        await axios.post(url, data)
        .then(response => {
          commit('LlenarItems',response.data.success.resultado);    
          commit('LlenarLoading',false)   
        })
        .catch(error => {
          this.errorMessage = error.response.data;
          console.error("error!", error);
        }); 
      } catch (error) {
        console.log(error)
      }
    },    
    agregarTipoCambio: async function({commit,dispatch},datos){
      var  url = "tipocambio/store";
      const data = { id_cliente: localStorage.getItem("idcliente"), tipocambio: datos}
      await axios.post(url,data)
      .then(response => {
        dispatch('cargarTipoCambio')     
      })
      .catch(error => {
        this.errorMessage = error.response.data;
        console.error("error!", error);
      }); 
    },    
  }

}


